const eventJSONLD = data => `{
  "@context": "http://www.schema.org",
  "@type": "Event",
  "name": "${data.headline}",
  "url": "${data.seo.links.canonical}",
  "description": "${data.introCopy.replace(/<(?:.|\n)*?>/gm, '')}",
  "image": "${data.seo.og.image ? `https://futurium.de${data.seo.og.image}` : ''}",
  "startDate": "${
    data.eventType.type === 'single' ? data.eventType.startTime.c : data.eventType.startDate.c
  }",
  "endDate": "${
    data.eventType.type === 'single' ? data.eventType.endTime.c : data.eventType.endDate.c
  }",
  "location": {
    "@type": "Place",
    "name": "${data.location.title}",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "${data.location.address.street}",
      "addressLocality": "${data.location.address.city}",
      "addressRegion": "${data.location.address.region}",
      "postalCode": "${data.location.address.zipcode}",
      "addressCountry": "Germany"
    }
  }
}`;

export default eventJSONLD;
